/** Impressum und Datenschutzerklärung des Anbieters (E8). Texte mit „# “/„## “ als Überschriften, Absätze durch Leerzeilen. */
import { z } from "zod";

export const Impressum = z.object({
  firma: z.string().trim().max(120).default(""),
  vertretenDurch: z.string().trim().max(120).default(""),
  strasse: z.string().trim().max(120).default(""),
  plz: z.string().trim().max(10).default(""),
  ort: z.string().trim().max(80).default(""),
  email: z.string().trim().max(120).default(""),
  telefon: z.string().trim().max(40).default(""),
  ustId: z.string().trim().max(20).default(""),
  register: z.string().trim().max(120).default(""),
  /** Verantwortlich für Inhalte nach § 18 Abs. 2 MStV, wenn abweichend. */
  inhaltlichVerantwortlich: z.string().trim().max(120).default(""),
  datenschutzbeauftragter: z.string().trim().max(160).default(""),
});
export type Impressum = z.infer<typeof Impressum>;

export const RechtlichesEingabe = z.object({
  impressum: Impressum,
  datenschutzText: z.string().max(60_000).default(""),
  freigegeben: z.boolean().default(false),
});
export type RechtlichesEingabe = z.infer<typeof RechtlichesEingabe>;

export const DATENSCHUTZ_ENTWURF = `# Datenschutzerklärung

Diese Erklärung beschreibt, welche personenbezogenen Daten MeinRegalladen verarbeitet, zu welchem Zweck und welche Rechte Sie haben. Sie gilt für die Web-App unter app.meinregalladen.de, das Mieterportal, die Kassen-Anwendung und die öffentlichen Regalseiten.

## Verantwortlicher

Für die Verarbeitung Ihrer Daten als Nutzerin oder Nutzer der Plattform ist der im Impressum genannte Anbieter verantwortlich. Für die Daten der Mieterinnen und Mieter eines Regalladens ist der jeweilige Laden verantwortlich; der Anbieter verarbeitet diese Daten in dessen Auftrag (Auftragsverarbeitung nach Art. 28 DSGVO).

## Hosting und Speicherort

Die Anwendung läuft bei Cloudflare, Inc. (Cloudflare Workers, D1, R2, KV, Queues). Alle Datenbanken und Dateispeicher sind auf die Jurisdiktion Europäische Union festgelegt. Es werden keine Schriften, Skripte oder Tracker von Drittanbietern geladen. Mit Cloudflare besteht ein Vertrag zur Auftragsverarbeitung mit EU-Standardvertragsklauseln.

## Welche Daten wir verarbeiten

Konto: E-Mail-Adresse, Name, Zeitpunkt der letzten Anmeldung, Sitzungen (Gerät und Browser als Text, letzte Aktivität), optional Zwei-Faktor-Geheimnis und Passkeys (nur öffentlicher Schlüssel).

Mieterinnen und Mieter: Name, Mieternummer, Kontaktdaten, Adresse, Bankverbindung (verschlüsselt, nur maskiert sichtbar), Mietverträge mit Zustimmungszeitpunkt und IP-Adresse, Artikel mit Fotos, Verkäufe, Abrechnungen und Auszahlungen.

Laden-Personal: Name, E-Mail, Rolle, PIN (nur als Hash), Protokoll der Änderungen.

Käuferinnen und Käufer: Die öffentliche Regalseite und die Kasse erheben keine Daten über Käufer. Die Zahlung läuft vollständig bei SumUp; wir erhalten von SumUp nur Betrag, Zeitpunkt, Zahlungsart und eine Transaktionsnummer, um sie einem Warenkorb zuzuordnen.

## Cookies und lokale Speicherung

Wir setzen ein technisch notwendiges Sitzungs-Cookie (rl_sitzung) für die Anmeldung. Es gibt keine Werbe- oder Analyse-Cookies. Das Mieterportal speichert Einstellungen wie Sprache und, wenn Sie offline Artikel erfassen, diese Artikel vorübergehend im Browser.

## E-Mail und Benachrichtigungen

Die Anmeldung erfolgt über einen Link per E-Mail. Wir versenden außerdem Vertrags-, Abrechnungs- und Erinnerungsmails. Push-Nachrichten aufs Handy sind freiwillig; dafür wird eine Adresse beim Push-Dienst Ihres Browsers (Apple, Google oder Mozilla) gespeichert, die Sie jederzeit im Profil abschalten können.

## Bot-Schutz

Zum Schutz der Anmeldung kann Cloudflare Turnstile eingesetzt werden. Turnstile wertet technische Merkmale des Browsers aus, ohne ein Nutzerprofil zu bilden.

## Speicherdauer

Buchhaltungsrelevante Daten (Verkäufe, Abrechnungen, Rechnungen, Auszahlungen, Änderungsprotokoll) bewahren wir nach § 147 AO zehn Jahre auf. Personenbezogene Daten von Mieterinnen und Mietern werden nach Vertragsende und Schlussabrechnung pseudonymisiert; die Buchhaltung bleibt unter der Mieternummer bestehen. Fotos, Vertrags-PDFs und Quittungen werden dabei gelöscht. Sitzungen laufen automatisch ab.

## Ihre Rechte

Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Mieterinnen und Mieter können im Portal eine Datenauskunft anfordern und ihr Konto selbst löschen, sobald keine Verträge und Guthaben mehr offen sind. Beschwerden sind bei einer Datenschutz-Aufsichtsbehörde möglich.

## Kontakt

Fragen zum Datenschutz richten Sie an die im Impressum genannte Adresse.`;
